require('./_wks-define')('asyncIterator');



//////////////////
// WEBPACK FOOTER
// /var/www/smartbuy.ru/~/babel-runtime/~/core-js/library/modules/es7.symbol.async-iterator.js
// module id = 613
// module chunks = 23 41